import React, { Component } from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { LoadingIndicator, Tile, CardTile, CustomSelect } from '../../components';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Courses from './courses.container';

class CourseView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedSorting: 'standard',
    };
  }

  componentWillMount() {

  }

  componentWillReceiveProps({ bulletinBoard }) {

  }


  handleSortingSelectChanged = (event) => {
    const sortingValue = event.target.value;
    let filter = {};

    switch (sortingValue) {
      case 'sortByCourseName': filter = { sortByCourseName: true }; break;
      case 'sortByGroupName': filter = { sortByName: true }; break;
      default: break;
    }

    if (this.props.bulletinBoard) { this.props.getPinnedContentAction(this.props.bulletinBoard.id, filter); }

    this.setState({
      selectedSorting: event.target.value,
    });
  }

  renderSortAndFilterSelect = () => (
    <FormControl style={{ marginBottom: 10, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      {/* <InputLabel htmlFor="age-customized-select">Age</InputLabel> */}
      <ExpandMoreIcon style={{ height: 30, width: 30 }} />
      <Select
        value={this.state.selectedSorting}
        onChange={this.handleSortingSelectChanged}
        IconComponent={() => null}
        input={<CustomSelect name="select" id="select_id" />}
      >
        <MenuItem value="standard" onClick={() => this.applyFilter()}>Standard</MenuItem>
        <MenuItem value="sortByCourseName" onClick={() => this.applyFilter('sortByCourseName')}>Kurs alphabetisch</MenuItem>
        <MenuItem value="sortByGroupName" onClick={() => this.applyFilter('sortByGroupName')}>Kursgruppe alphabetisch</MenuItem>
      </Select>
    </FormControl>
    )

  render() {
    return (
      <div className="col-lg-12 col-md-12 col-sm-12">
        <div className="col-md-12">
          {this.renderSortAndFilterSelect()}
        </div>
        <Courses
          disableSearch
          match={this.props.match}
          location={this.props.location}
          history={this.props.history}
          courseUrl={'courses'}
        />
      </div>
    );
  }
}

export default CourseView;



// WEBPACK FOOTER //
// ./src/app/main/bulletin-board/course-view.js